import { IPrintBehavior } from "./IPrintBehavior";

export class PrintBehavior {
  constructor(
    public shouldPrint: boolean         = true,   // 印刷要否.
    public shouldPreview: boolean       = true,   // 印刷プレビュー表示要否.
    // public shouldPrintOnEmpty: boolean  = true,   // 未入力時印刷要否. OfficeにはあるがV1では未実装
  ) {
  }

  clone(): PrintBehavior {
    return new PrintBehavior(this.shouldPrint, this.shouldPreview);
  }

  static from(source: IPrintBehavior): PrintBehavior {
    return new PrintBehavior(source.shouldPrint, source.shouldPreview);
  }

  static to(source: PrintBehavior): IPrintBehavior {
    return {
      shouldPrint: source.shouldPrint,
      shouldPreview: source.shouldPreview,
    };
  }
}
